export default __webpack_public_path__ + "static/media/crypto_voxels.6441d8a9.svg";